import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { LANG_KEY } from "@/context/LanguageContext";

// The homepage opens in English for a visitor who chose English with the
// FR/EN button; links to other pages are always respected.
function chosenEnglishHome() {
  try {
    return window.location.pathname === "/" && localStorage.getItem(LANG_KEY) === "en";
  } catch {
    return false;
  }
}

if (chosenEnglishHome()) {
  window.location.replace(`/en${window.location.search}${window.location.hash}`);
} else {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
